import { saveToken } from "utils/storage";
import { getUrlGetParams } from "utils/urls";

import DefaultAddress from "pages/DefaultAddress";

const ProxyLogin = () => {
  const { token } = getUrlGetParams();

  if (token) {
    saveToken(token);
  }

  return <DefaultAddress />;
};

export default ProxyLogin;
